import React from 'react';
import { Card, Typography } from 'antd';
import { DiscordFilled } from '@ant-design/icons';
import usePageMeta from '../hooks/usePageMeta';

function About() {
  const { Title, Paragraph, Text, Link } = Typography;
  usePageMeta('關於本專案 | 光暈戰記排行榜', 'https://twilightwarscloudflarereact.pages.dev/about');

  return (
    <div style={{ padding: '1.25rem' }}>
      <Card>
        <div style={{ marginBottom: '1rem' }}>
          <Title level={2} style={{ margin: 0 }}>關於本專案</Title>
        </div>

        <Typography>
          <Paragraph>
            本網站為社群玩家社群工具，<Text strong>非光暈戰記官方網站</Text>。
          </Paragraph>
          <Paragraph>
            本站僅向官方 API 發送請求以取得公開資料，並將整理後的統計資訊儲存在本站資料庫中，
            目的是便於玩家查閱每日排行榜、單日分數變化與上榜統計等資訊。
          </Paragraph>
          <Paragraph>
            若您發現資料有誤、或希望提出建議，歡迎透過下列方式聯繫我：
          </Paragraph>
        </Typography>

        <div style={{ display: 'flex', alignItems: 'center' ,gap: 12, padding: '1rem 0' }}>
          <DiscordFilled style={{ fontSize: 56, color: '#5865F2', lineHeight: 1 }} />
          <Text style={{ fontSize: 18 }}><Link href="https://discord.gg/8Tr9Rd8JQy">https://discord.gg/8Tr9Rd8JQy</Link></Text>
        </div>

        <Typography>
          <Title level={3} style={{ marginTop: '0.5rem' }}>技術與架構</Title>
          <Paragraph>本專案的運作方式與技術堆疊：</Paragraph>
          <ul style={{ paddingLeft: '1.25rem' }}>
            <li>前端：React + Ant Design + Recharts，部署於 Cloudflare Pages。</li>
            <li>後端與排程：Cloudflare Workers 週期性請求官方 API 取得公開排行榜資料（每 1 小時一次），並提供站內 API。</li>
            <li>資料儲存：Neon（PostgreSQL）做長期持久化；Upstash（Redis）作為快取／節流與暫存（每日排行榜/單日分數變化：600s；玩家上榜統計：1200s）。</li>
          </ul>
        </Typography>



        <Typography>
          <Paragraph type="secondary" style={{ marginTop: '1rem' }}>
            免責聲明：本網站不代表官方立場，所有資料與服務僅供參考。
          </Paragraph>
        </Typography>
      </Card>
    </div >
  );
}

export default About;




